// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.are-you-sure {
    position: fixed;
    left: 50%;
    top: 50%;
    transform: translateX(-50%) translateY(-50%);

    box-sizing: border-box;
    max-width: 650px;
    min-width: 340px;
    max-height: 100vh;

    text-align: center;
    padding: 20px;
    border: thin solid var(--main-border-color);
    border-radius: 10px;
    background-color: white;
    z-index: 1000;
}
.modal-overlay {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0,0,0,0.5);
    z-index: 999;
}
`, "",{"version":3,"sources":["webpack://./client/components/AreYouSure.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,SAAS;IACT,QAAQ;IACR,4CAA4C;;IAE5C,sBAAsB;IACtB,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;;IAEjB,kBAAkB;IAClB,aAAa;IACb,2CAA2C;IAC3C,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;AACjB;AACA;IACI,eAAe;IACf,OAAO;IACP,MAAM;IACN,WAAW;IACX,YAAY;IACZ,iCAAiC;IACjC,YAAY;AAChB","sourcesContent":[".are-you-sure {\n    position: fixed;\n    left: 50%;\n    top: 50%;\n    transform: translateX(-50%) translateY(-50%);\n\n    box-sizing: border-box;\n    max-width: 650px;\n    min-width: 340px;\n    max-height: 100vh;\n\n    text-align: center;\n    padding: 20px;\n    border: thin solid var(--main-border-color);\n    border-radius: 10px;\n    background-color: white;\n    z-index: 1000;\n}\n.modal-overlay {\n    position: fixed;\n    left: 0;\n    top: 0;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(0,0,0,0.5);\n    z-index: 999;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
